<ng-container *ngIf="companyFlagTypes$ | async as companyFlagTypes; else loading">
  <div class="mb-1" *ngFor="let item of companyFlagTypes">
    <nk-company-flag-tag [item]="item"></nk-company-flag-tag>
  </div>
</ng-container>

<ng-template #loading>
  <nk-spinner display="inline"></nk-spinner>
</ng-template>
